import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "banner";
var classes = {
    BANNER: 'tyl-banner',
    DISMISSED: 'tyl-banner--dismissed',
};
var selectors = {
    BANNER: '.tyl-banner',
    TCW_DISMISS_BUTTON: 'tcw-icon-button.tyl-banner__container-dismiss',
    DISMISS_BUTTON: '.tyl-banner__container-dismiss button',
    ICON: 'i',
    TCW_BUTTON: 'tcw-button'
};
var attributes = {
    SLOT: 'slot',
    DISMISSED: 'dismissed',
    CAN_DISMISS: 'can-dismiss',
    HIDDEN: 'hidden'
};
var slots = {
    ICON: 'icon',
    TEXT: 'text',
    BUTTON: 'button'
};
var events = {
    DISMISSED: elementName + "-dismissed",
    UNDISMISSED: elementName + "-undismissed"
};
export var BANNER_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    attributes: attributes,
    slots: slots,
    events: events
};
